/**
 * Vampires horde deck.
 * Source: hordemagic.com (300 cards: 150 tokens / 150 nontoken).
 * Scaled to ~100 cards preserving the 1:1 token:nontoken ratio.
 * All nontoken card names verified against local card DB.
 * Deviations:
 *   - "Innocent Traveler" stored as "Innocent Traveler // Malicious Invader" in DB;
 *     DFC fallback in resolve-horde endpoint handles single-face lookup.
 *   - "Edgar, Charmed Groom" stored as "Edgar, Charmed Groom // Edgar Markov's Coffin" in DB;
 *     DFC fallback handles it.
 * Tokens: "Vampire" (03a2f3c3) and "Vampire Knight" (8989fdb4) — real Scryfall printings.
 */
export const vampiresDeck = {
    id: 'vampires',
    name: 'Blood Tide',
    description: 'Noble lords of the night command a swarm of hungry vampire thralls.',
    cards: [
        // ── Tokens (50 total: 45 Vampire + 5 Vampire Knight) ───────────────────
        { name: 'Vampire', quantity: 45, isToken: true, scryfallId: '03a2f3c3-fbcb-4b21-8f86-232c0db80c1f' },
        { name: 'Vampire Knight', quantity: 5, isToken: true, scryfallId: '8989fdb4-723b-4c80-89b4-930ccac13b22' },
        // ── Legendary Creatures (20, 1x each) ───────────────────────────────────
        { name: 'Anowon, the Ruin Sage', quantity: 1, isToken: false },
        { name: 'Arvad the Cursed', quantity: 1, isToken: false },
        { name: 'Ascendant Evincar', quantity: 1, isToken: false },
        { name: 'Astarion, the Decadent', quantity: 1, isToken: false },
        { name: 'Drana, Kalastria Bloodchief', quantity: 1, isToken: false },
        { name: 'Drana, Liberator of Malakir', quantity: 1, isToken: false },
        { name: 'Drana, the Last Bloodchief', quantity: 1, isToken: false },
        { name: 'Edgar Markov', quantity: 1, isToken: false },
        { name: 'Edgar, Charmed Groom', quantity: 1, isToken: false },
        { name: 'Elenda, the Dusk Rose', quantity: 1, isToken: false },
        { name: 'Etrata, the Silencer', quantity: 1, isToken: false },
        { name: 'Evelyn, the Covetous', quantity: 1, isToken: false },
        { name: 'Kalitas, Bloodchief of Ghet', quantity: 1, isToken: false },
        { name: 'Kalitas, Traitor of Ghet', quantity: 1, isToken: false },
        { name: 'Lord Xander, the Collector', quantity: 1, isToken: false },
        { name: 'Olivia Voldaren', quantity: 1, isToken: false },
        { name: 'Olivia, Crimson Bride', quantity: 1, isToken: false },
        { name: 'Timothar, Baron of Bats', quantity: 1, isToken: false },
        { name: 'Vito, Thorn of the Dusk Rose', quantity: 1, isToken: false },
        { name: 'Zagras, Thief of Heartbeats', quantity: 1, isToken: false },
        // ── Support Creatures & Spells (30) ─────────────────────────────────────
        { name: 'Blood Artist', quantity: 1, isToken: false },
        { name: 'Butcher of Malakir', quantity: 2, isToken: false },
        { name: 'Captivating Vampire', quantity: 1, isToken: false },
        { name: 'Child of Night', quantity: 4, isToken: false },
        { name: 'Indulgent Aristocrat', quantity: 2, isToken: false },
        { name: 'Innocent Traveler', quantity: 2, isToken: false },
        { name: "Olivia's Wrath", quantity: 1, isToken: false },
        { name: 'Patron of the Vein', quantity: 1, isToken: false },
        { name: 'Rakish Heir', quantity: 2, isToken: false },
        { name: 'Ruinous Ultimatum', quantity: 1, isToken: false },
        { name: 'Sanguine Bond', quantity: 1, isToken: false },
        { name: 'Shared Animosity', quantity: 1, isToken: false },
        { name: 'Stensia Masquerade', quantity: 1, isToken: false },
        { name: 'Stromkirk Captain', quantity: 2, isToken: false },
        { name: 'Vampire Envoy', quantity: 3, isToken: false },
        { name: 'Vampire Nighthawk', quantity: 2, isToken: false },
        { name: 'Vampire Nocturnus', quantity: 1, isToken: false },
        { name: "Vampires' Vengeance", quantity: 1, isToken: false },
    ],
};
//# sourceMappingURL=vampires.js.map